/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type ProposalStatus = "ACCEPTED" | "DRAFT" | "DRAFT_WITH_CONFLICTS" | "ESCALATED" | "PROPOSED_OUTSIDE_MEETING";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProposeNow_proposal$ref: FragmentReference;
declare export opaque type ProposeNow_proposal$fragmentType: ProposeNow_proposal$ref;
export type ProposeNow_proposal = {|
  +id: string,
  +status: ProposalStatus,
  +databaseId: string,
  +canBeAccepted: boolean,
  +hasChanges: boolean,
  +expectedResponseCount: number,
  +organization: {|
    +asyncProposalsAreEnabled: boolean
  |},
  +circle: ?{|
    +isGovernanceEnabled: boolean
  |},
  +$refType: ProposeNow_proposal$ref,
|};
export type ProposeNow_proposal$data = ProposeNow_proposal;
export type ProposeNow_proposal$key = {
  +$data?: ProposeNow_proposal$data,
  +$fragmentRefs: ProposeNow_proposal$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProposeNow_proposal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeAccepted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasChanges",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expectedResponseCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "asyncProposalsAreEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Circle",
      "kind": "LinkedField",
      "name": "circle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGovernanceEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Proposal",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'beac24a9c7c396b0a46f9976175b09ac';

module.exports = node;
